<template>
  <van-cell :title="config.name" label="内容" title-class="custom-title">
    <template #label>
    <!--  <div class="check-item-detail-box">
        <span class="check-item-detail" v-if="controlList[0]==1">{{form.value01}}</span>
        <span class="check-item-detail" v-if="controlList[1]==1">{{form.value02}}</span>
        <span class="check-item-detail" v-if="controlList[2]==1">{{form.value03}}</span>
        <span class="check-item-detail" v-if="controlList[3]==1">参考值：{{referenceValue}}</span>
      </div> -->
  <van-row justify="space-between">
    <van-col span="2"><span class="check-item-detail" v-if="controlList[0]==1">{{form.value01}}</span></van-col>
    <van-col span="6"><span class="check-item-detail" v-if="controlList[1]==1">{{form.value02}}</span></van-col>
    <van-col span="6"> <span class="check-item-detail" v-if="controlList[2]==1">{{form.value03}}</span></van-col>
    <van-col span="10"><span class="check-item-detail" v-if="controlList[3]==1">参考值：{{referenceValue}}</span></van-col>
  </van-row>
    </template>
  </van-cell>
<!--  <div class="form-row form-row-1 check-item">
    <div class="form-item">
      <label class="form-item-left">{{config.name}} </label>
      <div class="form-item-right">
        <el-select v-model="form.value01" placeholder="" style="width: 100px;" @change="change"
          v-if="controlList[0]==1">
          <el-option v-for="item in typeOneList" :key="item" :label="item" :value="item">
          </el-option>
        </el-select>
        <el-input v-model="form.value02" style="width: 100px;" @change="change" v-if="controlList[1]==1">
        </el-input>

        <el-select v-model="form.value03" placeholder="请选择" style="width: 100px;" @change="change"
          v-if="controlList[2]==1">
          <el-option v-for="item in unitList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
        <span class="reference-title" v-if="controlList[3]==1">参考值：{{referenceValue}}</span>
      </div>
    </div>
  </div> -->
</template>

<script>
  export default {
    name: "page001",
    data() {
      return {
        form: {
          value01: "",
          value02: "",
          value03: "",
        },
        // 控件显示数组
        controlList: [1, 1, 1, 1],
        // 第一个下拉的列表
        typeOneList: ["=", "<", ">"],
        // 第三个控件-下拉的数据来源
        unitList: [],
        // 默认绑定的字段名
        propList: ["", "", ""],
        referenceValue: "",
      }
    },
    props: {
      // 配置对象
      config: {
        type: Object,
        default: function() {
          return {
            guid: "",
            name: "",
          }
        }
      },
      value: {
        type: Object,
        default: function() {
          return {}
        }
      }
    },
    created() {
      let that = this
      // 如果传递了控件数组,按照传递数组情况绑定
      if (that.config.hasOwnProperty("controlList")) {
        that.controlList = that.config.controlList
      }

      // 获得传递进来的属性数组,设置对应的属性数组
      if (that.config.hasOwnProperty("propList")) {
        that.propList = that.config.propList
      }
      
      // 获得传递进来的属性数组,设置对应的属性数组
      if (that.config.hasOwnProperty("unitList")) {
      	that.unitList = that.config.unitList
      	if(that.form.value03=='' && that.unitList.length>0){
      		that.form.value03 = that.unitList[0]				
      	}
      }
      // 获得传递进来的属性数组,设置对应的属性数组
      if (that.config.hasOwnProperty("referenceValue")) {
      	that.referenceValue = that.config.referenceValue.join(',')
      }

    },
    watch: {
      // 绑定的值
      value() {
        // alert(1)
        if (this.value.hasOwnProperty("guid") && this.value.guid) {
          this.setValue()
        }
      }
    },
    methods: {
      change() {
        let that = this
        // 设置要提交给父辈的对象
        // 这里根据配置的propList,返回对应的二属性名
        let reModel = {}
        // 循环属性数组
        that.propList.forEach(function(item, key) {
          // 如果当前数组存在值,则将当前属性赋值给reModel
          // 同时，根据key相同的原则，将form中的数据推给reModel[item]
          if (item) {
            reModel[item] = that.form['value0' + (key + 1)]
          }
        })
        // 提交给父辈
        that.$emit("setFormData", reModel)
      },
      // 编辑模式下,根据info接口的值，设置对应的数据
      setValue() {
        let that = this
        // 循环属性数组
        that.propList.forEach(function(item, key) {
          // 属性有值
          if (item) {
            // value 默认绑定从value01 开始,这里需要将key+1
            that.form['value0' + (key + 1)] = that.value[item]
          }
        })
      }
    },
    mounted() {
      let that = this
      if (that.value.hasOwnProperty("guid") && that.value.guid) {
        that.setValue()
      }

    }
  }
</script>

<style scoped>
  .check-item-detail-box{
    padding-top: 5px;
    font-size: 14px;
  }
  
  .check-item-detail{
    color: #444;
    padding-right: 10px;
  }
  
  .check-item-box .van-cell{
    border-bottom: 1px solid #ccc;
  }
</style>
